import React, { useState, useContext, useEffect } from 'react';
import { useSearchParams, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import './header-active-panel.scss';

import { Avatar, DropdownMenu, Text, Button } from '@ui-kit';
import { UserContext } from '@shared/hooks';
import { geShortCut } from '@shared';
import { AvatarLabel, HeaderActiveLang } from '@features';
import { 
  getLocale, 
  setLocaleAC, 
  setModalLoginShowAC, 
  setModalSignupShowAC,
} from '@entities';
import { ROLES } from '@entities/user';
import LogoutSmal from '@ui-kit/icons/logout-gray700.svg';

import { MENU_LIST, MENU_LIST_ADMIN } from './header-active.consts';

const HeaderPanel = ({ logout = () => {} }) => {
  const dispatch = useDispatch();
  const user = useContext(UserContext);
  const locale = useSelector(getLocale)
  const location = useLocation();
  const [showMenu, setShowMenu] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();

  const { isUserAuth = null, ava = null } = user;

  const isUser = user.role === ROLES.USER;
  const userMenu = isUser ? MENU_LIST : MENU_LIST_ADMIN;

  const langTitle = () => {
    switch(locale) {
      case 'ru': return 'Ru'
      case 'uk': return 'Uk'
      default  : return 'En'
    }
  }
  useEffect(() => {
    const referral = searchParams.get('referral');
    const hash = location.hash;

    if (referral) {
      localStorage.setItem('referral', referral)
    }

    if (hash && hash === '#login') {
      viewModalLogin();
    }

    if (hash && hash === '#signup') {
      viewModalSignup();
    }

    // eslint-disable-next-line
  }, [location.pathname]);

  const selectLanguage = (value) => {
    dispatch(setLocaleAC(value));
    searchParams.set('lang', value);
    setSearchParams(searchParams, {replace: true});
  }

  const LOGOUT_COMPONENT = {
    component: (
      <Text as="span" onClick={logout} className="menu_logout">
        Log out
      </Text>
    ),
    icon: LogoutSmal,
  };

  let menuListWithAvatarLabel = [
    {
      component: (
        <AvatarLabel
          author={user}
          showEmail={true}
          className="menu-hover__disabled"
        />
      ),
      isDivider: true,
    },
    ...userMenu,
    LOGOUT_COMPONENT,
  ];

  const onClickInternal = (value) => {
    setShowMenu(value);
  };

  const onVisibleChange = () => {
    setShowMenu(false);
  };

  const viewModalLogin = () => {
    dispatch(setModalSignupShowAC(false));
    dispatch(setModalLoginShowAC(true));
  }

  const viewModalSignup = () => {
    dispatch(setModalLoginShowAC(false));
    dispatch(setModalSignupShowAC(true));
  }

  const getActions = () => {
    if (isUserAuth) {
      return (
        <div className="d-flex ai-center">
          <HeaderActiveLang 
            title={langTitle()}
            selectLanguage={selectLanguage}
            className="mr-30"
          />
          <DropdownMenu
            menu_list={menuListWithAvatarLabel}
            onVisibleChange={onVisibleChange}
            isVisible={showMenu}
            classes="menu-default"
            placement="bottomLeft"
          >
            <Avatar
              user={user}
              src={ava}
              status={true}
              className="drop-down__ava"
              text={geShortCut(user.firstName, user.lastName)}
              onClick={() => onClickInternal(!showMenu)}
            />
          </DropdownMenu>
        </div>
      );
    }

    return (
      <div className="d-flex ai-center ml-18 notauth">
        <HeaderActiveLang 
          title={langTitle()}
          selectLanguage={selectLanguage}
        />
        <Button onClick={viewModalLogin} theme="tertiary-gray">
          Log in
        </Button>
        <Button onClick={viewModalSignup} className="ml-12" size="lg">
          Sign up
        </Button>
      </div>
    );
  };

  return <div className="header__panel d-flex ai-center">{getActions()}</div>;
};

export default HeaderPanel;
